export interface AuthorizationWindow {
  readonly closed: boolean;
  opener: unknown;
  readonly location: { replace(url: string): void };
  close(): void;
}

type OpenAuthorizationWindow = (
  url?: string | URL,
  target?: string,
) => AuthorizationWindow | null;

/**
 * Open synchronously from the click so browser popup protection recognises the
 * user gesture. The authorization URL arrives later from the API.
 */
export function openAuthorizationWindow(
  openWindow: OpenAuthorizationWindow = (url, target) =>
    window.open(url, target),
): AuthorizationWindow | null {
  const opened = openWindow("about:blank", "_blank");
  if (opened !== null) opened.opener = null;
  return opened;
}

export function navigateAuthorizationWindow(
  opened: AuthorizationWindow,
  authorizationUrl: string,
): boolean {
  if (opened.closed) return false;
  try {
    opened.location.replace(authorizationUrl);
    return true;
  } catch {
    return false;
  }
}
